import { all } from "redux-saga/effects";
import {
  fetchClaimPaymentRetryWatcher,
  fetchClaimPaymentRetryQueueWatcher,
  requestClaimPaymentRetryWatcher,
  reviewClaimPaymentRetryWatcher,
} from "./claimPaymentRetry";
import {
  submitFundsLoadWatcher,
  fetchLoadableBusinessesWatcher,
  fetchFundsLoadMembersWatcher,
} from "./fundsLoad";
import {
  fetchPersonEffectiveDateWatcher,
  updatePersonEffectiveDateWatcher,
  resetPersonPasswordWatcher,
} from "./personAccount";
import {
  changePasswordWatcher,
  confirmForgotPasswordWatcher,
  forgotPasswordWatcher,
  renewVerificationCodeWatcher,
  respondToAuthChallengeWatcher,
  signInWatcher,
  signoutWatcher,
  changeRoleWatcher,
  checkEmailWatcher,
  resendVerificationWatcher,
  confirmVerificationWatcher,
  setNewPasswordWatcher,
  setNewEmailWatcher,
  fetchTerminatedUserWatcher,
  confirmForgotPasswordVerificationWatcher,
  triggerSelfEnrolmentVerificationCodeWatcher,
  respondToMfaChallengeWatcher,
  getMfaStatusWatcher,
  updatePhoneNumberWatcher,
  sendPhoneVerificationCodeWatcher,
  verifyPhoneWatcher,
  enableMfaWatcher,
  disableMfaWatcher,
  associateSoftwareTokenWatcher,
  verifySoftwareTokenWatcher,
  enableSoftwareTokenMfaWatcher,
} from "./auth";
import {
  createBrokerWatcher,
  fetchBhaBrokersWatcher,
  fetchBrokerDetailsWatcher,
  fetchFullBrokersWatcher,
  updateBrokerDetailsWatcher,
  updateBrokerWatcher,
} from "./broker";
import {
  fetchCompanyBankWatcher,
  fetchCompanyPadWatcher,
  updateCompanyBankWatcher,
  updateCompanyPadWatcher,
} from "./companyBank";
import { fetchCompanyForClassesWatcher } from "./companyClasses";
import {
  fetchCompanyEftPullWatcher,
  updateCompanyEftPullWatcher,
} from "./companyEftPull";
import { updateCompanyContactWatcher, createBillingContactWatcher, removeCompanyContactWatcher } from "./companyContacts";
import {
  createBrokerageHouseWatcher,
  fetchBanksWatcher,
  fetchBrokerageHouseInfoWatcher,
  fetchBrokerageHousesWatcher,
  updateBrokerageHouseWatcher,
} from "./brokerageHouse";
import {
  fetchClaimCategoriesWatcher,
  fetchClaimsWatcher,
  fetchNotesWatcher,
  getClaimWatcher,
  updateClaimItemWatcher,
  updateClaimWatcher,
  updateNotesWatcher,
  uploadClaimImageWatcher,
  createClaimWatcher,
  submitClaimWatcher,
  batchClaimImageUploadWatcher,
  createAndSubmitClaimWatcher,
  fetchMastercardClaimWatcher,
  fetchClaimImagesWatcher,
  submitMastercardClaimWatcher,
  fetchClaimUsageStatsWatcher,
  fetchClaimEligibilityWatcher,
  analyzeClaimDocumentsWatcher,
  analyzeClaimDocumentWatcher,
  setDocumentAnalysisQueryWatcher,
} from "./claims";
import {
  createCompanyWatcher,
  createNewPlanAdminWatcher,
  fetchAccountantsWatcher,
  fetchAuthorizedSignersWatcher,
  fetchAyaSalesRepsWatcher,
  fetchBeneficiaryOwnersWatcher,
  fetchCompaniesWatcher,
  fetchDirectorsWatcher,
  fetchFullCompaniesWatcher,
  fetchIndustriesWatcher,
  fetchPcoTpaWatcher,
  fetchPlanSponsorAdministratorPrimaryWatcher,
  fetchPlanSponsorAdministratorWatcher,
  fetchPlanSponsorContactWatcher,
  fetchProductCodesWatcher,
  getCompanyDetailsWatcher,
  getCompanyWatcher,
  getNewPlanAdminWatcher,
  updateCompanyWatcher,
  updateNewPlanAdminWatcher,
  fetchCompanyAllInfoWatcher,
  getCompanyInvoiceFileWatcher,
  getInvoiceListWatcher,
  getReportwatcher,
  getBalanceswatcher,
  getSelfEnrolmentUserDataWatcher,
  getSelfEnrolmentCompanyDataWatcher,
  saveSelfEnrolmentCompanyDataWatcher,
  createSelfEnrolmentCompanyWatcher,
  submitSelfEnrolmentCompanyDataWatcher,
  getAllSelfEnroledCompaniesWatcher,
  getSelfEnroledCompanyDetailsWatcher,
  setApproveSelfEnroledCompanyWatcher,
  startSelfEnrolmentForCompanyWatcher,
  sendSelfEnrolmentInviteWatcher,
  setDeclineSelfEnroledCompanyWatcher,
  setSubmitSelfEnroledCompanyWatcher,
  saveReviewedSelfEnrolmentCompanyDataWatcher,
  triggerPcoEnrolmentWatcher,
  addClassWatcher,
  updateClassWatcher,
  fetchClassesWatcher,
  createCompanyEnrolmentWatcher,
  saveCompanyEnrolmentDataWatcher,
  getAllEnroledCompaniesWatcher,
  setApproveEnroledCompanyWatcher,
  setDeclineEnroledCompanyWatcher,
  // saveReviewedEnroledCompanyDataWatcher,
  getEnroledCompanyDetailsWatcher,
  submitCompanyEnrolmentDataWatcher,
  savePcoEnrolmentDetailsWatcher,
  submitSinglePcoEnrolmentWatcher,
  getEnroledPcoEnrolmentDetailsWatcher,
} from "./company";
import {
  createDependentWatcher,
  updateDependentsWatcher,
  fetchDependentWatcher,
} from "./dependent";
import {
  patchEmployeeWatcher,
  terminateEmployeeWatcher,
  reinstateEmployeeWatcher,
  createEmployeeWatcher,
  fetchEmployeesWatcher,
  fetchFullEmployeesWatcher,
  updateEmployeeWatcher,
  fetchPlanHSAWSAWatcher,
  fetchPlanDetailsWatcher,
  resendEmployeeEmailWatcher,
  fetchEmployeeDetailsWatcher,
  updateEmployeeDetailsWatcher,
  updateEmployeeCardDetailsWatcher,
  fetchEmployeeInviteDataWatcher,
  fetchEmployeeCardsWatcher,
  activateEmployeeCardWatcher,
  fetchEmployeeCraHsaInfoWatcher,
  updateEmployeeCardPinWatcher,
  triggerPinVerificationWatcher,
  fetchAccountDeletionInfoWatcher,
  triggerAccountDeletionWatcher,
  triggerAccDelVerificationCodeWatcher,
  accountDeletionCancellationWatcher,
  updateFlexAllocationWatcher,
  updateContributionWatcher,
  updateEmployeeAllocationWatcher,
  fetchGenderListWatcher,
  fetchCountryListWatcher,
  fetchIdentityTypeListWatcher,
  fetchOccupationListWatcher,
  fetchProvinceListWatcher,
  upsertKycWatcher,
  getKycStatusWatcher,
  verifyAddressWatcher,
  fetchAdminKycPersonWatcher,
  getAdminKycStatusWatcher,
  upsertAdminKycWatcher,
  fetchAdminCardsWatcher,
  updateAdminCardStatusWatcher,
  reissueAdminCardWatcher,
  issueAdminCardWatcher,
  reportAdminCardLostWatcher,
  fetchAdminDependentsWatcher,
  createAdminDependentWatcher,
  deleteAdminDependentWatcher,
} from "./employee";
import { verifyBusinessAddressWatcher } from "./businessAddress";
import { fetchAgreementsWatcher, setModalWatcher } from "./general";
import { fetchDashboardStatsWatcher, fetchCompanyStatsWatcher } from "./stats";
import { createTPAWatcher, fetchTPASWatcher, updateTPAWatcher } from "./tpa";
import {
  createTpaSrWatcher,
  fetchFullTpaSrsWatcher,
  updateTpaSrWatcher,
} from "./tpaSr";
import {
  fetchPaymentsListWatcher,
  fetchPaymentWatcher,
  updatePaymentStatusWatcher,
  createNewPaymentWatcher,
  fetchBankWatcher,
  updateBankWatcher,
} from "./payments";
import {
  fetchInvoiceDetailsWatcher,
  fetchInvoicesWatcher,
  sendInvoiceWatcher,
  createJournalWatcher,
} from "./invoice";
import {
  fetchLedgerStatsWatcher,
  fetchLedgerWatcher,
  createMemoTransactionWatcher,
} from "./ledger";
import { updateMasterCardStatusWatcher } from "./mastercard";
import { fetchCartaReportsWatcher, fetchCarta04Watcher } from "./processor";
import { fetchMerchantListWatcher } from "./merchant";
import { fetchSuperAdminsWatcher, fetchUsersListWatcher } from "./superAdmin";
import { registerSensiBillWatcher, createSensiBillWatcher } from "./sensiBill";
import { getSlsWatcher, getSlsByIdWatcher, editSlsByIdWatcher } from "./sls";

export default function* root() {
  yield all([
    fetchTerminatedUserWatcher(),
    setNewEmailWatcher(),
    signInWatcher(),
    fetchAgreementsWatcher(),
    renewVerificationCodeWatcher(),
    signoutWatcher(),
    changePasswordWatcher(),
    changeRoleWatcher(),
    respondToAuthChallengeWatcher(),
    forgotPasswordWatcher(),
    confirmForgotPasswordWatcher(),
    createBrokerWatcher(),
    updateBrokerWatcher(),
    fetchFullBrokersWatcher(),
    fetchBhaBrokersWatcher(),
    fetchBrokerDetailsWatcher(),
    updateBrokerDetailsWatcher(),
    fetchCompanyBankWatcher(),
    updateCompanyBankWatcher(),
    fetchCompanyPadWatcher(),
    updateCompanyPadWatcher(),
    fetchCompanyForClassesWatcher(),
    fetchCompanyEftPullWatcher(),
    updateCompanyEftPullWatcher(),
    updateCompanyContactWatcher(),
    createBillingContactWatcher(),
    removeCompanyContactWatcher(),
    fetchFullTpaSrsWatcher(),
    createTpaSrWatcher(),
    updateTpaSrWatcher(),
    fetchBrokerageHousesWatcher(),
    fetchBanksWatcher(),
    createBrokerageHouseWatcher(),
    updateBrokerageHouseWatcher(),
    fetchTPASWatcher(),
    createTPAWatcher(),
    updateTPAWatcher(),
    fetchPlanSponsorContactWatcher(),
    fetchPlanSponsorAdministratorPrimaryWatcher(),
    fetchPlanSponsorAdministratorWatcher(),
    getCompanyWatcher(),
    getCompanyDetailsWatcher(),
    fetchCompaniesWatcher(),
    fetchProductCodesWatcher(),
    fetchFullCompaniesWatcher(),
    createNewPlanAdminWatcher(),
    updateNewPlanAdminWatcher(),
    getNewPlanAdminWatcher(),
    fetchPlanHSAWSAWatcher(),
    fetchPlanDetailsWatcher(),
    resendEmployeeEmailWatcher(),
    createCompanyWatcher(),
    patchEmployeeWatcher(),
    terminateEmployeeWatcher(),
    reinstateEmployeeWatcher(),
    updateCompanyWatcher(),
    fetchEmployeesWatcher(),
    createEmployeeWatcher(),
    updateEmployeeWatcher(),
    createDependentWatcher(),
    updateDependentsWatcher(),
    fetchDependentWatcher(),
    fetchClaimCategoriesWatcher(),
    fetchIndustriesWatcher(),
    fetchPcoTpaWatcher(),
    fetchNotesWatcher(),
    updateNotesWatcher(),
    fetchClaimsWatcher(),
    getClaimWatcher(),
    updateClaimWatcher(),
    updateClaimItemWatcher(),
    createClaimWatcher(),
    submitClaimWatcher(),
    batchClaimImageUploadWatcher(),
    fetchCompanyStatsWatcher(),
    fetchDashboardStatsWatcher(),
    fetchAuthorizedSignersWatcher(),
    fetchDirectorsWatcher(),
    fetchBeneficiaryOwnersWatcher(),
    fetchAccountantsWatcher(),
    fetchAyaSalesRepsWatcher(),
    fetchFullEmployeesWatcher(),
    fetchPaymentsListWatcher(),
    fetchPaymentWatcher(),
    updatePaymentStatusWatcher(),
    createNewPaymentWatcher(),
    fetchBankWatcher(),
    updateBankWatcher(),
    fetchInvoiceDetailsWatcher(),
    fetchInvoicesWatcher(),
    sendInvoiceWatcher(),
    createJournalWatcher(),
    fetchLedgerStatsWatcher(),
    updateMasterCardStatusWatcher(),
    uploadClaimImageWatcher(),
    fetchLedgerWatcher(),
    createMemoTransactionWatcher(),
    fetchCartaReportsWatcher(),
    fetchMerchantListWatcher(),
    fetchCarta04Watcher(),
    fetchSuperAdminsWatcher(),
    fetchBrokerageHouseInfoWatcher(),
    setModalWatcher(),
    fetchUsersListWatcher(),
    setModalWatcher(),
    fetchEmployeeDetailsWatcher(),
    updateEmployeeDetailsWatcher(),
    updateEmployeeCardDetailsWatcher(),
    updateEmployeeCardPinWatcher(),
    triggerPinVerificationWatcher(),
    fetchEmployeeInviteDataWatcher(),
    checkEmailWatcher(),
    resendVerificationWatcher(),
    confirmVerificationWatcher(),
    setNewPasswordWatcher(),
    confirmForgotPasswordVerificationWatcher(),
    registerSensiBillWatcher(),
    createSensiBillWatcher(),
    createAndSubmitClaimWatcher(),
    getSlsWatcher(),
    getSlsByIdWatcher(),
    editSlsByIdWatcher(),
    fetchClaimUsageStatsWatcher(),
    fetchMastercardClaimWatcher(),
    fetchClaimImagesWatcher(),
    submitMastercardClaimWatcher(),
    fetchCompanyAllInfoWatcher(),
    fetchEmployeeCardsWatcher(),
    activateEmployeeCardWatcher(),
    fetchEmployeeCraHsaInfoWatcher(),
    getCompanyInvoiceFileWatcher(),
    getInvoiceListWatcher(),
    getReportwatcher(),
    getBalanceswatcher(),
    fetchAccountDeletionInfoWatcher(),
    triggerAccountDeletionWatcher(),
    triggerAccDelVerificationCodeWatcher(),
    accountDeletionCancellationWatcher(),
    triggerSelfEnrolmentVerificationCodeWatcher(),
    respondToMfaChallengeWatcher(),
    getMfaStatusWatcher(),
    updatePhoneNumberWatcher(),
    sendPhoneVerificationCodeWatcher(),
    verifyPhoneWatcher(),
    enableMfaWatcher(),
    disableMfaWatcher(),
    associateSoftwareTokenWatcher(),
    verifySoftwareTokenWatcher(),
    enableSoftwareTokenMfaWatcher(),
    getSelfEnrolmentUserDataWatcher(),
    getSelfEnrolmentCompanyDataWatcher(),
    saveSelfEnrolmentCompanyDataWatcher(),
    createSelfEnrolmentCompanyWatcher(),
    submitSelfEnrolmentCompanyDataWatcher(),
    getAllSelfEnroledCompaniesWatcher(),
    getSelfEnroledCompanyDetailsWatcher(),
    setApproveSelfEnroledCompanyWatcher(),
    startSelfEnrolmentForCompanyWatcher(),
    sendSelfEnrolmentInviteWatcher(),
    setDeclineSelfEnroledCompanyWatcher(),
    setSubmitSelfEnroledCompanyWatcher(),
    saveReviewedSelfEnrolmentCompanyDataWatcher(),
    triggerPcoEnrolmentWatcher(),
    updateFlexAllocationWatcher(),
    updateContributionWatcher(),
    updateEmployeeAllocationWatcher(),
    addClassWatcher(),
    updateClassWatcher(),
    fetchClassesWatcher(),
    createCompanyEnrolmentWatcher(),
    saveCompanyEnrolmentDataWatcher(),
    getAllEnroledCompaniesWatcher(),
    setApproveEnroledCompanyWatcher(),
    setDeclineEnroledCompanyWatcher(),
    // saveReviewedEnroledCompanyDataWatcher(),
    getEnroledCompanyDetailsWatcher(),
    submitCompanyEnrolmentDataWatcher(),
    savePcoEnrolmentDetailsWatcher(),
    submitSinglePcoEnrolmentWatcher(),
    getEnroledPcoEnrolmentDetailsWatcher(),
    fetchClaimEligibilityWatcher(),
    analyzeClaimDocumentsWatcher(),
    analyzeClaimDocumentWatcher(),
    setDocumentAnalysisQueryWatcher(),
    fetchGenderListWatcher(),
    fetchCountryListWatcher(),
    fetchIdentityTypeListWatcher(),
    fetchOccupationListWatcher(),
    fetchProvinceListWatcher(),
    upsertKycWatcher(),
    getKycStatusWatcher(),
    fetchAdminKycPersonWatcher(),
    getAdminKycStatusWatcher(),
    upsertAdminKycWatcher(),
    fetchAdminCardsWatcher(),
    updateAdminCardStatusWatcher(),
    reissueAdminCardWatcher(),
    issueAdminCardWatcher(),
    reportAdminCardLostWatcher(),
    fetchAdminDependentsWatcher(),
    createAdminDependentWatcher(),
    deleteAdminDependentWatcher(),
    verifyAddressWatcher(),
    verifyBusinessAddressWatcher(),
    fetchClaimPaymentRetryWatcher(),
    fetchClaimPaymentRetryQueueWatcher(),
    requestClaimPaymentRetryWatcher(),
    reviewClaimPaymentRetryWatcher(),
    submitFundsLoadWatcher(),
    fetchLoadableBusinessesWatcher(),
    fetchFundsLoadMembersWatcher(),
    fetchPersonEffectiveDateWatcher(),
    updatePersonEffectiveDateWatcher(),
    resetPersonPasswordWatcher(),
  ]);
}
